import { createEvent, createStore } from 'effector';
import {
  chatShowOnlyMssages,
  ChatShowOnlyMssages,
  chatTabsTypes,
  ChatTabsTypes,
} from '../../types/chat-tabs';

export const $activeChatTab = createStore<ChatTabsTypes>(chatTabsTypes.employees);
export const setActiveChatTab = createEvent<ChatTabsTypes>();

export const $showOnlyInMainChat = createStore<ChatShowOnlyMssages>(
  chatShowOnlyMssages.notHidden
);

export const TICKET_CHANNEL_TAB_PARAM_NAME = 'ticket_channel_tab';
export const TICKET_CHANNEL_TAB_VALUE_SUPPORT = 'support';
